import { mapState } from 'vuex';
import storyPreview from "@/components/modules/stories/preview/index.vue";
import story from "@/components/modules/stories/story/index.vue";
export default {
    name: 'withpreview',
    props: {
        id : String,
        composedStory : Object,
        closeWhenEnd : Boolean,
        wnd : Boolean,
        autoplay : Boolean,
        fromtime : Number,
        topmodal : Boolean,
        nocontrols : Boolean,
        showCourse : Boolean,
        silencemode : Boolean,
        circle : Boolean,
        checkAccess : Array
    },

    components : {
        storyPreview,
        story
    },

    data : function(){

        return {
            loading : false,
            initedStory : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        gotostory : function(){

            if(this.checkAccess && !this.core.user.checkFeatures(this.checkAccess)) return

            this.initedStory = true
        }
       
    },
}